import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  fill: "none",
  viewBox: "0 0 18 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#222",
      d: "m10.35 9 2.925-2.925a.71.71 0 0 0 .206-.525.71.71 0 0 0-.206-.525.71.71 0 0 0-.525-.206.71.71 0 0 0-.525.206l-3.45 3.45a.7.7 0 0 0-.16.244.862.862 0 0 0 0 .563q.046.13.16.243l3.45 3.45a.71.71 0 0 0 .525.206.71.71 0 0 0 .525-.206.71.71 0 0 0 .206-.525.71.71 0 0 0-.206-.525zm-5.1-4.5a.73.73 0 0 0-.535.216.72.72 0 0 0-.215.534v7.5q0 .319.216.535a.72.72 0 0 0 .534.215.73.73 0 0 0 .534-.216A.72.72 0 0 0 6 12.75v-7.5a.72.72 0 0 0-.216-.534.73.73 0 0 0-.534-.216"
    }, null, -1)
  ]))]))
}
export default { render: render }